<template>
  <div class="app-footer">
    <div class="app-footer-container" :style="maxWidthStyle">
      <footer-indicator :version="appVersion" />
      <div class="spacer"></div>
      <footer-navigation :options="navigationOptions" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { IOrganization, IUser } from '@rready/sdk';
import { useAuthStore } from '../../store/authStore';
import { useContextStore } from '../../store/contextStore';
import { useProductStore } from '../../store/productStore';

export default defineComponent({
  props: {
    maxWidth: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      appVersion: ''
    };
  },
  async created(): Promise<void> {
    const { version } = await this.$api.users.fetchVersionNumber();
    this.appVersion = version;
  },
  computed: {
    currentUser(): IUser {
      return useAuthStore().user?.raw;
    },
    getOrganization(): IOrganization {
      return useContextStore().organization;
    },
    productId(): string | undefined {
      return this.$route.params.product;
    },
    getCurrentProductId(): string {
      return useProductStore().productId!;
    },
    navigationOptions(): any[] {
      if (!this.productId) {
        return [];
      }
      const customization =
        this.getOrganization.productCustomization?.[this.productId];
      return (
        customization?.footerLinks?.map((it: any) => {
          const resource = this.$res<Record<string, string>>(it.resources);
          return {
            label: resource.title,
            href: resource.link
          };
        }) ?? []
      );
    },
    maxWidthStyle(): string {
      return this.maxWidth ? `max-width: ${this.maxWidth}px` : '';
    }
  }
});
</script>

<style lang="scss" scoped>
.app-footer {
  margin-top: 40px;
  background-color: #fafafa;
  border-top: 1px solid #e6e6e6;
}

.app-footer-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 18px;
  min-height: 80px;
  margin: 0 auto;
  padding: 12px 20px;
}

.spacer {
  flex-grow: 1;
}
</style>
